import useGetAccountData from 'features/account/ui/common/useGetAccountData'

interface UserPermissions {
  sharingMapsAvailable?: boolean
  exportViewportDataAvailable?: boolean
  exportPdfReportAvailable?: boolean
  enterpriseBrandingAvailable?: boolean
  builderCustomCodeAvailable?: boolean
}

function useUserPermissions(): UserPermissions {
  const accountData = useGetAccountData()
  const quotas = accountData?.quotas

  return {
    sharingMapsAvailable: quotas?.shareMapsAvailable,
    exportViewportDataAvailable: accountData?.exportViewportDataAvailable,
    exportPdfReportAvailable: accountData?.exportPdfReportAvailable,
    enterpriseBrandingAvailable: accountData?.enterpriseBrandingAvailable,
    builderCustomCodeAvailable: accountData?.builderCustomCodeAvailable
  }
}

export default useUserPermissions
